import mietminderung from '../../fields/cases/mietminderung';

export const QUERY_GET_MM_CASE = /* GraphQL */ `
	query($id: String!) {
		getMietminderungCase(id: $id) {
			${mietminderung}
		}
	}
`;
